import {Directive, HostListener, input} from '@angular/core';
import {ScrollManagerService} from '@core/service/scroll-manager.service';

@Directive({
  selector: '[appScrollTo]'
})
export class ScrollToDirective {

  public readonly appScrollTo = input.required<string>();

  public constructor(private readonly scrollManager: ScrollManagerService) {}

  @HostListener('click')
  public scroll() {
    this.scrollManager.scroll(this.appScrollTo());
  }

}
